import script from "./primary-button.vue?vue&type=script&setup=true&lang=js"
export * from "./primary-button.vue?vue&type=script&setup=true&lang=js"

import "./primary-button.vue?vue&type=style&index=0&id=6f2f34c8&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2f34c8"]])

export default __exports__